// Tuft.jo wishlist — localStorage-backed, mirrors the cart pattern.
// The original static site never actually shipped this (a header icon that
// linked to a wishlist.html page that was never built) — this is a real,
// working implementation using the same storage-and-events approach.
(function () {
  const KEY = 'tj.wishlist.v1';

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  };
  const save = (items) => {
    localStorage.setItem(KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('tj:wish-changed', { detail: items }));
  };

  window.tjWish = {
    items: () => read(),
    has: (handle) => read().some((x) => x.handle === handle),
    toggle: (handle, title, image, price, url) => {
      let items = read();
      const i18n = window.TJ_I18N || {};
      if (items.some((x) => x.handle === handle)) {
        items = items.filter((x) => x.handle !== handle);
        save(items);
        if (window.tjToast) window.tjToast(i18n.wishlistRemovedToast || '× Removed from wishlist');
        return false;
      }
      items.push({ handle, title, image, price, url });
      save(items);
      const savedMsg = (i18n.wishlistSavedToast || '♥ Saved to wishlist: %%TITLE%%').replace('%%TITLE%%', title);
      if (window.tjToast) window.tjToast(savedMsg);
      return true;
    },
  };

  function syncButtons() {
    document.querySelectorAll('.tj-fav-btn').forEach((btn) => {
      btn.classList.toggle('on', window.tjWish.has(btn.dataset.favHandle));
    });
  }
  function updateBadges() {
    const count = window.tjWish.items().length;
    document.querySelectorAll('.tj-wish-badge').forEach((b) => {
      b.textContent = count;
      b.hidden = count === 0;
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.tj-fav-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    window.tjWish.toggle(
      btn.dataset.favHandle,
      btn.dataset.favTitle,
      btn.dataset.favImage,
      btn.dataset.favPrice,
      btn.dataset.favUrl
    );
    syncButtons();
    updateBadges();
  });

  document.addEventListener('DOMContentLoaded', () => {
    syncButtons();
    updateBadges();
  });
  window.addEventListener('tj:wish-changed', () => {
    syncButtons();
    updateBadges();
  });
})();
